/**
 * @generated SignedSource<<ba159a91674374225c7eb6658b509a93>>
 * @relayHash cb457fe22f3415d160d9c995a7a1d1c2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8764a45d0de9f9d95947200f9d2f2d62b99ca49a5036ba89d08934fbe00a18d3

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GlobalProductsSettingsSidebarQuery$variables = {
  cloudId: string;
  skipDelegatedAdminCheck: boolean;
  skipSiteWfoStatus: boolean;
};
export type GlobalProductsSettingsSidebarQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DelegatedAdminJiraSection" | "ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts">;
};
export type GlobalProductsSettingsSidebarQuery = {
  response: GlobalProductsSettingsSidebarQuery$data;
  variables: GlobalProductsSettingsSidebarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipDelegatedAdminCheck"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipSiteWfoStatus"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GlobalProductsSettingsSidebarQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "skipDelegatedAdminCheck",
            "variableName": "skipDelegatedAdminCheck"
          }
        ],
        "kind": "FragmentSpread",
        "name": "DelegatedAdminJiraSection"
      },
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "skipSiteWfoStatus",
            "variableName": "skipSiteWfoStatus"
          }
        ],
        "kind": "FragmentSpread",
        "name": "ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GlobalProductsSettingsSidebarQuery",
    "selections": [
      {
        "condition": "skipDelegatedAdminCheck",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "alias": "canManageCustomOnboarding",
                "args": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "MANAGE_CUSTOM_ONBOARDING"
                  }
                ],
                "kind": "ScalarField",
                "name": "hasGlobalPermission"
              }
            ]
          }
        ]
      },
      {
        "condition": "skipSiteWfoStatus",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              (v1/*: any*/)
            ],
            "concreteType": "AgentWorkspaceSiteWfoStatus",
            "kind": "LinkedField",
            "name": "agentWorkspace_siteWfoStatus",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasProjectEnabledWfo"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8764a45d0de9f9d95947200f9d2f2d62b99ca49a5036ba89d08934fbe00a18d3",
    "metadata": {},
    "name": "GlobalProductsSettingsSidebarQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "81ff1f6d7d4bee54d7a26279bb3171ae";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
